import { v4 as uuid4 } from 'uuid'
import { reactive } from 'vue'
import type { App as Application } from 'vue'

import type { LNotificationProps } from '../../components/Notifications/types'

export type LNotificationParams = Omit<LNotificationProps, 'id'> & { id?: string }

const notifications: LNotificationProps[] = reactive([])

export function useNotification() {
  function create(newNotification: LNotificationParams): string {
    const notification = {
      ...newNotification,
      id: newNotification.id ?? uuid4()
    }

    notifications.unshift(notification)

    return notification.id
  }

  function updateProgress(id: string, progress: number): void {
    const notificationIndex = notifications.findIndex(notification => notification.id === id)
    const notification = notifications[notificationIndex]
    if (notification && notification.progress) {
      notification.progress.value = progress
    }
  }

  function close(id: string): void {
    const notificationIndex = notifications.findIndex(notification => notification.id === id)
    if (notificationIndex !== -1) {
      notifications.splice(notificationIndex, 1)
    }
  }

  return {
    notifications,
    create,
    updateProgress,
    close
  }
}

export const LNotificationPlugin = {
  install(app: Application) {
    app.config.globalProperties.$lnotification = useNotification
    app.provide('$lnotification', useNotification)
  }
}
